import script from "./HomePage_Activity.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage_Activity.vue?vue&type=script&setup=true&lang=js"

import "./HomePage_Activity.vue?vue&type=style&index=0&id=b9435df4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9435df4"]])

export default __exports__